import React, { SVGProps } from 'react'
const SvgHideHover = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="nonzero"
        d="M21.58 12.525a.75.75 0 0 1 0 .95c-6.3 7.7-12.86 7.7-19.16 0a.75.75 0 0 1 0-.95c6.3-7.7 12.86-7.7 19.16 0ZM12 16.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm0-1.5a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5Z"
      />
      <path
        stroke={props.stroke || 'var(--color-cta)'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M18.502 19.502 4.967 5.967"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M20.002 19.002 6.467 5.467m11.535 15.535L4.467 7.467"
      />
    </g>
  </svg>
)
export default SvgHideHover
